import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Auth.css';
import AdUnit from './AdUnit';
import { GoogleLogin } from '@react-oauth/google';
import {jwtDecode } from "jwt-decode";

const API_URL = process.env.REACT_APP_API_URL;// || 'http://localhost:3001/api';
const GCP_PRD_API_URL = process.env.PRD_API_URL;

// Event vocabulary (same as prediction page)
const EVENT_VOCABULARY = [
  {
    category: "EDUCATION",
    events: [
      { code: "edsas08", label: "Finished Middle School" },
      { code: "edsas12", label: "Finished High School" },
      { code: "edhebba", label: "Enroll in BBA" },
      { code: "edhgbba", label: "Graduated BBA" },
      { code: "edhebeg", label: "Enrolled in B.E." },
      { code: "edhgbeg", label: "Graduated B.E." }
    ]
  },
  {
    category: "CAREER",
    events: [
      { code: "crrsjnj", label: "Start new job" },
      { code: "crrprjb", label: "Promotion" },
      { code: "crrlqjb", label: "Leave the job" },
      { code: "crrrtjb", label: "Retire from job" }
    ]
  },
  {
    category: "FAMILY",
    events: [
      { code: "socpwfd", label: "Go on a date" },
      { code: "socpmrr", label: "Marriage" },
      { code: "socnb01", label: "Birth of Child" },
      { code: "socpdvd", label: "Got divorced" }
    ]
  },
  {
    category: "HEALTH",
    events: [
      { code: "hthchgn", label: "A medical condition" },
      { code: "hthchgn", label: "An Azthma condition" },
      { code: "hthchgn", label: "A cancer diagnosis" }
    ]
  },
  {
    category: "LOCATION",
    events: [
      { code: "prsbapr", label: "Own apartment/house" },
      { code: "prssafp", label: "Own apartment/house with partner" },
      { code: "prslctr", label: "Relocate within country" },
      { code: "prslstt", label: "Relocate within State" }
    ]
  }
];

const EVENT_DESCRIPTIONS = {
  "edsas08": "Attend grade 8 in school",
  "edsas12": "Attend grade 12 in school",
  "edhebba": "Enroll with a Bachelor of Business",
  "edhgbba": "Graduate with a Bachelor of Business",
  "edhebeg": "Enroll with a BE",
  "edhgbeg": "Graduate with a Bachelor Eng",
  "crrsjnj": "Start a new job",
  "crrprjb": "Promotion in job",
  "crrlqjb": "Change job",
  "crrrtjb": "Retire from job",
  "prsbapr": "Buy an apartment or a house",
  "prssafp": "Buy an apartment or a house with partner",
  "socpwfd": "Go on a date with someone",
  "socpmrr": "Get married",
  "socpdvd": "Get a divorce",
  "socnb01": "A New born first child",
  "hthchgn": "Might have a chronic health condition",
  "prslctr": "Relocate within Country",
  "prslstt": "Relocate within State",

  };

const AdSensePlaceholder = ({ position }) => (
  <div className="adsense-placeholder">
    <div className="ad-content">
      <span className="ad-label"></span>
      <p className="ad-text">{/*AdSense Ad #position*/}
        <AdUnit adSlot="7314445474" /> {/* Use your actual ad slot ID */}
      </p>
    </div>
  </div>
);

/*
const AdTimer = ({ onComplete }) => {
  const [timeLeft, setTimeLeft] = useState(5);

  useEffect(() => {
    if (timeLeft > 0) {
      const timer = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
      return () => clearTimeout(timer);
    } else {
      onComplete();
    }
  }, [timeLeft, onComplete]);

  return (
    <div className="ad-timer-overlay">
      <div className="ad-timer-content">
        <div className="ad-timer-box">
          <p className="ad-timer-text">Please watch this brief ad</p>
          <div className="ad-timer-circle">{timeLeft}</div>
          <p className="ad-timer-hint">Sign up for more daily predictions!</p>
        </div>
      </div>
    </div>
  );
};
*/
const Login = ({ onLogin }) => {
  const [ user, setUser ] = useState([]); //to handle the user object from google register.
  const [ profile, setProfile ] = useState([]); //to handle the user profile from google register.
  
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [resetEmail, setResetEmail] = useState('');
  const [resetMessage, setResetMessage] = useState('');

  // Guest prediction state
  const [guestEvents, setGuestEvents] = useState(['', '', '', '']);
  const [guestPrediction, setGuestPrediction] = useState(null);
  const [guestAttempts, setGuestAttempts] = useState(0);
  //const [showAdTimer, setShowAdTimer] = useState(false);
  const [attemptsLocked, setAttemptsLocked] = useState(false);
  const [predictLoading, setPredictLoading] = useState(false);
  const [predictError, setPredictError] = useState('');


  useEffect(() => {
    const storedData = localStorage.getItem('guestPredictionAttempts');
    if (storedData) {
      const { count, timestamp } = JSON.parse(storedData);
      const now = new Date().getTime();
      const twentyFourHours = 24 * 60 * 60 * 1000;
      
      // Check if 24 hours have passed
      if (now - timestamp < twentyFourHours) {
        setGuestAttempts(count);
        if (count >= 2) {
          setAttemptsLocked(true);
        }
      } else {
        // Reset after 24 hours
        localStorage.removeItem('guestPredictionAttempts');
      }
    }
  }, []);

  const handleSocialRegisterApple = async (provider) => {}
  
  const handleSocialRegisterGoogle = async (credentialResponse) => {
  /////mrn : handle google oauth login
    //setError('');
    //alert(`${provider} OAuth integration - Implement OAuth flow in production`);

    const gcontent = JSON.stringify({
          credential: credentialResponse.credential, })
          //console.log(gcontent);
          console.log("Pemail: " + jwtDecode(gcontent).email + " ProviderId: "+jwtDecode(gcontent).sub);



    try {
      const response = await fetch(`${API_URL}/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          email: jwtDecode(gcontent).email,
          provider: 'google',
          providerId: jwtDecode(gcontent).sub
        })
      });

      //body: JSON.stringify({ email, password })

      const data = await response.json();
      if (response.ok) {
        onLogin(data.token, data.user);
      }
    } catch (err) {
      setError('Social login failed');
    }
   // }
  };

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setResetMessage('');
    setError('');

    if (!resetEmail) {
      setError('Please enter your email address');
      return;
    }

    try {
      const response = await fetch(`${API_URL}/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: resetEmail })
      });

      const data = await response.json();

      if (response.ok) {
        setResetMessage(data.message || 'Password reset email sent. Please check your inbox.');
        setTimeout(() => {
          setShowForgotPassword(false);
          setResetMessage('');
          setResetEmail('');
        }, 5000);
      } else {
        setError(data.error || 'Failed to send reset email');
      }
    } catch (err) {
      setError('Network error. Please try again.');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await fetch(`${API_URL}/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
      });

      const data = await response.json();

      if (response.ok) {
        // Check if email is verified
        if (!data.emailVerified) {
          setError('Please verify your email before logging in. Check your inbox for the verification link.');
          setLoading(false);
          return;
        }
        onLogin(data.token, data.user);
      } else {
        setError(data.error || 'Login failed');
      }
    } catch (err) {
      setError('We could not find you. Are you sure of the email? perheps (reset) the password?');
    } finally {
      setLoading(false);
    }
  };

  const handleGuestEventChange = (index, value) => {
    const newEvents = [...guestEvents];
    newEvents[index] = value;
    setGuestEvents(newEvents);
  };

  const handleGuestPredict = async () => {
    setPredictError('');
    setGuestPrediction(null);

    const filledEvents = guestEvents.filter(e => e !== '');
    if (filledEvents.length < 2) {
      setPredictError('Please select at least 2 events');
      return;
    }

    if (guestAttempts >= 2) {
      //setShowAdTimer(true);
      setPredictError('Daily limit reached. Please sign up for unlimited predictions!');
      setAttemptsLocked(true);
      return;
    }

    setPredictLoading(true);

    try {
      //working:const response = await fetch('http://127.0.0.1:5000/predict', {
      //        const response = await fetch('http://192.168.1.32:5000/predict', {

          console.log(GCP_PRD_API_URL + "/predict");
        const response = await fetch('https://prediction-api-302792922407.us-central1.run.app/predict', {

      //        const response = await fetch(`${GCP_PRD_API_URL}/predict`, {
      //        const response = await fetch('${GCP_PRD_API_URL}/predict', {

        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ event_sequence: filledEvents })
      });

      const data = await response.json();

      if (data.status === 'success') {
        setGuestPrediction(data.prediction_summary);
        const newCount = guestAttempts + 1;
        setGuestAttempts(guestAttempts + 1);
        
        // Refresh ads after 2 attempts
        /*if (guestAttempts + 1 >= 2) {
          setTimeout(() => {
            window.location.reload();
          }, 10000);
        }*////////
        const attemptData = {
        count: newCount,
        timestamp: new Date().getTime()
        };
        localStorage.setItem('guestPredictionAttempts', JSON.stringify(attemptData));
        
        if (newCount >= 2) {
          setAttemptsLocked(true);
        }
        
      } else {
        setPredictError('Prediction failed');
      }
    } catch (err) {
      setPredictError('Prediction API not available');
    } finally {
      setPredictLoading(false);
    }
  };
/*
  const handleAdComplete = () => {
    setShowAdTimer(false);
    setGuestAttempts(0);
  };*/

  if (showForgotPassword) {
    return (
      <div className="auth-page">
        <div className="cosmic-bg"></div>
        <div className="auth-container">
          <div className="auth-card">
            <button 
              className="back-btn"
              onClick={() => setShowForgotPassword(false)}
            >
              ← Back to Login
            </button>
            
            <div className="auth-header">
              <h1 className="auth-title">🔮 Reset Password</h1>
              <p className="auth-subtitle">Enter your email to receive a reset link</p>
            </div>

            <form onSubmit={handleForgotPassword} className="auth-form">
              <div className="input-group">
                <label className="input-label">📧 Email Address</label>
                <input
                  type="email"
                  className="auth-input"
                  value={resetEmail}
                  onChange={(e) => setResetEmail(e.target.value)}
                  placeholder="your@email.com"
                  required
                />
              </div>

              <button type="submit" className="auth-submit-btn">
                Send Reset Link
              </button>

              {resetMessage && (
                <div className="success-message">
                  <span className="success-icon">✓</span>
                  {resetMessage}
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page login-landing">
    <header className="static-header">
        <nav className="static-nav">
          <div className="logo" onClick="location.href='https://www.mellodai.com';"> Mellodai</div>
          <a href='https://www.mellodai.com'> Back to Home</a>
        </nav>
      </header>

      <div className="cosmic-bg"></div>
      
      <div className="landing-container">
        {/* Guest Prediction Section */}
        <div className="guest-prediction-section">
          <div className="guest-header">
            <h1 className="guest-title">Mellodai gives you an AI glimpse on the future.</h1>
            <p className="guest-subtitle">what and when will the next major event come your way.</p>
            
          </div>

          <div className="guest-content-grid">
            {/* Left AdSense */}
            <div className="guest-sidebar">
             <div className="guest-form-card" >
              {/* HTML code for the description starts here */}
                <div className="event-label">
                    <h2>📜 From Ancient Oracles to AI: The Human Quest to Predict the Future</h2>
                    <p>Since the dawn of humanity, we've shared a fundamental desire: to forecast the future. This universal curiosity isn't new; it's a deep-seated impulse to understand and prepare for what lies ahead.</p>
                    <p>Throughout history, people have explored countless methods to gain insight into the future. Some practices were rooted in spiritual or mystical belief systems, ranging from reading horoscopes and tarot cards to interpreting other symbolic signs.</p>
                    <p>Simultaneously, more scientific and systematic approaches began to emerge. Great civilizations built vast repositories of knowledge, recognizing that by collecting and categorizing information, they could discern patterns and make better predictions. This is evident in the legendary libraries of ancient Greeks, Egyptians, Persia, and Mesopotamia. This pursuit of terrestrial records continued through innovations like the Almanac in Spain, and the detailed astronomical and terrestrial records compiled by scholars like Ulugh Beg and Galileo. Whether for agricultural planning, navigating the stars, or anticipating social trends, both commoners and scientists diligently kept records to forecast future events.</p>
                    <br/>
                    <br/>
                    <h2>💻 The Age of Data and Probabilistic Forecasting</h2>
                    <p>Today, we stand at a revolutionary crossroads. The sheer volume of datasets generated by human interaction—from our daily movements to our digital activities—is unprecedented. This wealth of information is the fuel for Artificial Intelligence (AI), enabling a new era of calculated, probabilistic forecasting.</p>
                    <p>We see this everywhere: Google Maps uses real-time traffic data to predict your arrival time, and vast networks of sensors and atmospheric measurements power reliable weather forecasts. Every prediction, whether predicting next week's rain or tomorrow's traffic jam, offers a powerful insight into the future. These are not prophecies, but scientifically determined probabilities.</p>
                    <br/>
                    <br/>
                    <h2>📈 Your Personal AI forecasting Engine➡️ </h2>
                    <p>Here on our page, we are leveraging this modern capability. We have painstakingly collected and analyzed 30 years of major life event data from thousands of individuals. This vast, anonymized dataset allows our AI model to identify significant patterns and trends.</p>
                    <p>Now, you can harness this historical data to calculate the probability of your own predicted future event.</p>
                    <p>To begin your calculation, please proceed to the form below. Enlist your past major actions and life events in the designated fields, and our system will calculate the statistical probability of your next major predicted event, giving you a unique data-driven perspective on your future trajectory.</p>
                    <br/>
                    <br/>
                    <h2>🔑 Examples of Major Life Events to Input:</h2>
                    <ul>
                        <li>🎓 Education & Training: Graduated from high school / secondary school, Graduated from university / college, Completed a major certification or training course</li>
                        <li>💼 Career & Work: Started a first job, Got a major promotion, Started or closed a business, Made a major investment (e.g., buying a home)</li>
                        <li>❤️ Relationships & Family: Went out on a first date with a significant partner, Got engaged or married, Had a child, Moved into a new city or country</li>
                        <li>🏠 Lifestyle & Health: Made a significant lifestyle change (e.g., quitting a bad habit), Completed a major personal goal (e.g., running a marathon), Experienced a major health event or recovery</li>
                    </ul>
                </div>
              {/* it ends here.*/}
             </div>
            </div>

            {/* Prediction Form */}
            <div className="guest-form-container">
              
              <div className="guest-form-card">
                <h3 className="form-title">🔮 Try a forecast by selecting a chronological sequence of main events:</h3>
                {/* start replacement here */}
                <div className="guest-event-grid">
                {guestEvents.map((event, index) => (
                  <div key={index} className="guest-event-slot">
                    <label className="event-label"> </label>
                    <select
                      className="guest-event-select"
                      value={event}
                      onChange={(e) => handleGuestEventChange(index, e.target.value)}
                    >
                      <option value="">-- Select chronlogically --</option>
                      {EVENT_VOCABULARY.map(category => {
                        const totalEvents = category.events.length;
                        const freeEvents = totalEvents - 2; // Lock last 2 events
                        
                        return (
                          <optgroup key={category.category} label={category.category}>
                            {category.events.map((evt, eventIndex) => {
                              const isLocked = eventIndex >= freeEvents;
                              return (
                                <option 
                                  key={evt.code} 
                                  value={isLocked ? '' : evt.code}
                                  disabled={isLocked}
                                  style={{
                                    color: isLocked ? '#666' : 'inherit',
                                    fontStyle: isLocked ? 'italic' : 'normal'
                                  }}
                                >
                                  {isLocked ? `🔒 ${evt.label} ` : evt.label}
                                </option>
                              );
                            })}
                          </optgroup>
                        );
                      })}
                    </select>
                  </div>
                ))}
              </div>
                {/* End replacement here */}
                <div className="guest-predict-container">
                  {/*showAdTimer && <AdTimer onComplete={handleAdComplete} />  */}
                  <button
                    className="guest-predict-btn"
                    onClick={handleGuestPredict}
                    disabled={predictLoading || attemptsLocked}
                  >
                    {predictLoading ? 'Predicting...' : attemptsLocked ? '🔒 Daily Limit Reached' : '✨ Get Prediction'}
                    {/*predictLoading ? 'Predicting...' : '✨ Get Prediction'*/}
                    
                  </button>
                  <p className="attempts-counter">
                    Attempts: {guestAttempts}/2 {attemptsLocked && '(Resets in 24h)'}
                  </p>
                </div>


                {predictError && (
                  <div className="predict-error">{predictError}</div>
                )}

                {guestPrediction && (
                  <div className="guest-result">
                    <h4 className="result-heading">Your Prediction:</h4>
                    <p className="result-event">
                      {EVENT_DESCRIPTIONS[guestPrediction.top_prediction.event]}
                    </p>
                    <p className="result-confidence">
                      {(guestPrediction.top_prediction.probability * 100).toFixed(1)}% confidence as highest probability and it will occur after 🔒🔒🔒 months and the other 4 predictions are 🔒🔒🔒.
                    </p>
                  </div>
                )}
                <h3 className="form-title"><br/><Link to="/register" className="auth-link">Sign Up</Link> to unlock 🔓 all events, save your sequences, get timely predictions and forecast for multiple other people! Receive a comprehensive prediction report.</h3>
              </div>
              <p></p>
            </div>
            
           
            {/* Right login & register */}
            <div className="auth-container-inline">
              <div className="auth-card">
                
                  <h3 className="form-title">✨ Sign In for accuracy and personalization</h3>
                  <p className="auth-subtitle"> save up to 8 sequences and get comprehensive results.</p><br/>
                

                <form onSubmit={handleSubmit} className="auth-form">
                  <div className="input-group">
                    
                    <input
                      type="email"
                      className="auth-input"
                      value={email} //reset after adsense review
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="📧your@email.com" reset after adsense review
                      required
                    />
                  </div>

                  <div className="input-group">
                    
                    <input
                      type="password"
                      className="auth-input"
                      value={password} //reset after adsense review
                      onChange={(e) => setPassword(e.target.value)}
                      placeholder="🔒••••••••" reset after adsense review
                      required
                    />
                  </div>

                  

                  {error && (
                    <div className="error-message">
                      <span className="error-icon">⚠️</span>
                      {error}
                    </div>
                  )}

                  <button 
                    type="submit" 
                    className="auth-submit-btn"
                    disabled={loading}
                  >
                    {loading ? 'Signing in...' : 'Sign In'}
                  </button>
                </form>
                <button 
                    type="button" 
                    className="forgot-password-link"
                    onClick={() => setShowForgotPassword(true)}
                  >
                    Forgot password?
                  </button>
                <div className="divider">
                  <span>or continue with</span>
                </div>

                <div className="social-buttons"></div>

                  
                    <div className="google-login-wrapper">
                                <GoogleLogin
                                onSuccess={handleSocialRegisterGoogle}
                                onError={() => console.log('Google Register Failed')}
                                useOneTap={false}
                                disabled={loading}
                              /></div>
                
                <div className="auth-footer">
                  <p>
                    Don't have an account? 
                    <Link to="/register" className="auth-link">Sign Up</Link>
                  </p>
                </div>

                {/* Disclaimer Link */}
                <div className="disclaimer-link-container">
                  <Link to="/disclaimer" className="disclaimer-link">
                    <span className="disclaimer-icon">⚠️</span>
                    <span>View AI Usage & Disclaimer</span>
                  </Link>
                </div>
              </div>
            </div>
            {/* Login Section ends */}
          
            
          </div>
        </div>

        {//isFree && (
            <div className="modal-sidebar">
              <AdSensePlaceholder />{/* Place the AdUnit component here */}
              
            </div>
        //  )
        }
        
      </div>
    </div>
  );
};

export default Login;